// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rvZF","newExpiryDate":"styles_newExpiryDate__jqFSl","footer":"styles_footer__10X8B"};